import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../types/commonTypes";
import { Company } from "../types/companyTypes";
import companyApi from "../api/companyApi";

interface CompanyState {
  loadState: LoadState;
  companies: Company[];
  createLoadState: LoadState;
}

const initialState: CompanyState = {
  loadState: LoadState.INIT,
  companies: [],
  createLoadState: LoadState.INIT,
};

export const companySlice = createSlice({
  name: "CompanyState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(companyApi.endpoints.getCompanies.matchPending, (state) => {
        state.loadState = LoadState.LOADING;
      })
      .addMatcher(
        companyApi.endpoints.getCompanies.matchFulfilled,
        (state, { payload }) => {
          state.loadState = LoadState.LOADED;
          state.companies = payload;
        }
      )
      .addMatcher(companyApi.endpoints.getCompanies.matchRejected, (state) => {
        state.loadState = LoadState.ERROR;
      });
    // .addMatcher(
    //   companyApi.endpoints.adminGetCompanies.matchPending,
    //   (state) => {
    //     state.loadState = LoadState.LOADING;
    //   }
    // )
    // .addMatcher(
    //   companyApi.endpoints.adminGetCompanies.matchFulfilled,
    //   (state, { payload }) => {
    //     state.loadState = LoadState.LOADED;
    //     state.companies = payload;
    //   }
    // )
    // .addMatcher(
    //   companyApi.endpoints.adminGetCompanies.matchRejected,
    //   (state) => {
    //     state.loadState = LoadState.ERROR;
    //   }
    // )
    // .addMatcher(
    //   companyApi.endpoints.adminCreateCompany.matchPending,
    //   (state) => {
    //     state.createLoadState = LoadState.LOADING;
    //   }
    // )
    // .addMatcher(
    //   companyApi.endpoints.adminCreateCompany.matchFulfilled,
    //   (state, { payload }) => {
    //     state.createLoadState = LoadState.LOADED;
    //     state.companies = [...state.companies, payload];
    //   }
    // )
    // .addMatcher(
    //   companyApi.endpoints.adminCreateCompany.matchRejected,
    //   (state) => {
    //     state.createLoadState = LoadState.ERROR;
    //   }
    // );
  },
});

export default companySlice.reducer;
